module.exports = __webpack_public_path__ + "img/folio-tablet.36531c0.jpg";